// extracted by mini-css-extract-plugin
export default {"background":"g__background--UzLvQ"};